export enum SellerInsightsPhotoRecommendationsType {
  NeedsImprovement = 'items_need_improvement',
  AllImproved = 'all_items_improved',
  NoItems = 'no_items_found',
}

export enum SellerBadgeType {
  ActiveLister = 'ACTIVE_LISTER',
  FastReplier = 'FAST_REPLIER',
  SpeedyShipper = 'SPEEDY_SHIPPING',
}
